import Vue from 'vue';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import { Ingredient } from '@/models/Ingredient'
import IngredientService from '@/services/IngredientService'
const ingredientService = new IngredientService()
import axios from 'axios'
import { orderBy } from 'lodash'

export interface IngredientState {
  ingredients: Array<Ingredient>;
  cosing: Array<Ingredient>;
  prohibited: Array<Ingredient>;
  restricted: Array<Ingredient>;
}

const state: IngredientState = {
  ingredients: [],
  cosing: [],
  prohibited: [],
  restricted: [],
}

const mutations: MutationTree<IngredientState> = {
  SET_COSING(state: any, data: Array<any>) {
    state.cosing = data
  },
  SET_PROHIBITED(state: any, data: Array<any>) {
    state.prohibited = data
  },
  SET_RESTRICTED(state: any, data: Array<any>) {
    state.restricted = data
  },
  ADD_INGREDIENT(state: any, ingredient: Ingredient) {
    const index = state.ingredients.findIndex((obj: Ingredient) => obj.reference === ingredient.reference)
    if (index < 0) {
      state.ingredients.push(ingredient)
    }
  },
  CLEAR_INGREDIENTS(state: any) {
    state.ingredients = []
  }
}

const actions: ActionTree<IngredientState, any> = {
  setCosing({ commit }, data) {
    commit('SET_COSING', data)
  },
  setProhibited({ commit }, data) {
    commit('SET_PROHIBITED', data)
  },
  setRestricted({ commit }, data) {
    commit('SET_RESTRICTED', data)
  },
  clearIngredients({ commit }) {
    commit('CLEAR_INGREDIENTS')
  },
  async fetchIngredient({ commit, dispatch, state }, payload): Promise<any> {
    const { reference, projectId } = payload;
    // check if exists
    const index = state.ingredients.findIndex((obj: Ingredient) => obj.reference == reference);
    if (index > -1) return Promise.resolve(state.ingredients[index]);

    // find in cosing
    const res = state.cosing.find((item: Ingredient) => item.reference === reference);
    let item = JSON.parse(JSON.stringify(res));
    if (item) {
      item = await dispatch('hasEvaluation', { projectId, item })
      commit('ADD_INGREDIENT', item)
      return Promise.resolve(item);
    } else {
      return Promise.reject();
    }
  },
  async queryIngredients({ commit, dispatch, state }, payload) {
    const { projectId, options } = payload
    const limit = state.ingredients.length + 10;

    let sortBy, sortDesc = null;
    if (options && options.sortBy && options.sortDesc && options.sortBy.length === 1 && options.sortDesc.length === 1) {
      sortBy = options.sortBy[0]
      sortDesc = options.sortDesc[0]
    }

    const sortOrder: ('asc' | 'desc')[] = sortDesc ? ['desc'] : ['asc'];
    const arr: Array<Ingredient> =
      orderBy(state.cosing, ['' + sortBy], sortOrder)
        .slice(state.ingredients.length, limit);

    for await (let item of arr) {
      item = await dispatch('hasEvaluation', { projectId, item })
      commit('ADD_INGREDIENT', item)
    }
  },
  async hasEvaluation({ dispatch }, payload) {
    const { projectId, item } = payload;
    const evaluation = await dispatch('projectIngredients/hasEvaluation', { projectId, item }, { root: true });
    if (evaluation) {
      item.hasEvaluation = true;
      item.evaluationId = evaluation.id;
    }
    return item;
  }
}

const getters: GetterTree<IngredientState, RootState> = {
  getIngredients: (state) => {
    return state.ingredients
  },
  getCosing: (state) => {
    return state.cosing
  },
  getRestricted: (state) => {
    return state.restricted
  },
  getProhibited: (state) => {
    return state.prohibited
  },
  getIngredient: (state: any) => (ref: string) => {
    return state.ingredients.find((item: any) => item.reference === ref);
  },
  getCosingByItem: (state: any) => (ref: string) => {
    return state.ingredients.find((item: any) => item.reference === ref);
  },
  getIngredientsByListOfIds: (state) => (ids: Array<string>) => {
    const arr: Array<Ingredient> = []
    state.ingredients.map((ingredient: Ingredient) => {
      ids.map(ref => {
        if (ref === ingredient.reference) {
          arr.push(JSON.parse(JSON.stringify(ingredient)))
        }
      })
    })
    return arr
  },
  isProhibited: (state: any) => (item: Ingredient) => {
    if (!item.casNumber && item.casNumber === "" || !item || item.casNumber === "-") return false;
    return state.prohibited.find((cos: Ingredient) => {
      return cos.casNumber != "" && cos.casNumber.includes(item.casNumber)
    });
  },
  isRestricted: (state: any) => (item: Ingredient) => {
    if (!item.casNumber || item.casNumber === "" || !item || item.casNumber === "-") return false;
    if (item.restriction && item.restriction != "") return true;

    return state.restricted.find((cos: Ingredient) => {
      return !cos.casNumber && cos.casNumber != "" && cos.casNumber.includes(item.casNumber)
    });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
